(ns io.daskul.webapp.widgets.layout.sidebar
  "What is left of the right rail.

   It used to carry four unrelated jobs at equal visual weight — transitions,
   the state chip, read-only fields and audit metadata — which is why nothing
   in it was emphasised. F-060 took them apart:

     transitions + state chip -> the record header      (#696)
     read-only pinned fields  -> the pinned-facts strip (#699)
     created / updated        -> a quiet line at the foot of Details (#699)

   What remains is alerts, and the Activity widget the page mounts separately.
   `format-relative` stays here because record-meta renders the same wording."
  (:require
   [uix.core :refer [defui $]]
   [io.daskul.webapp.ui :as ui]))

(defui edit-sidebar
  "Note-severity alerts, and nothing else.

   These are ordinary alerts (F-059, #701) at severity `:note` — a standing
   statement with nothing to do about it, on a record whose chip usually
   already says the same thing. They resolve through the same pipeline as
   every other alert; they simply do not earn a banner, so they render here,
   quietly, exactly where they rendered before they became alerts.

   Read from `[:_meta :alerts]` rather than from the FSM state config: the
   server has already evaluated `:when` and filled in the state predicate
   from each declaration site, so this does not need to know which of the
   two sites the message came from.

   Everything this component used to draw now lives where F-060 puts it (see
   the ns docstring). It renders NOTHING when there are no alerts — the old
   version guarded the card on `has-fsm?`, so every record with an FSM and
   nothing to say still drew an empty bordered box. That box was visible on
   the Lead detail and is the bug this closes.

   Props:
     notes - resolved alerts at severity :note, from [:_meta :alerts]."
  [{:keys [notes]}]
  (when-let [alerts (seq notes)]
    ($ ui/paper {:p "md" :withBorder true :data-testid "record-alerts"}
      ($ ui/stack {:gap "sm"}
        (for [alert alerts]
          ($ ui/alert {:key (str (:id alert))
                       :color "gray"
                       :variant "light"
                       :radius "md"}
            (:title alert)))))))
